// extracted by mini-css-extract-plugin
module.exports = {"value":"style_value__26Qrj","label":"style_label__2o7ls"};